import { UPI_INTENT } from "./constants";
import { UpiIntentItems } from "./types";
import { IMAGE_CDN_URL } from "../../lib/utils/constants";

export const UPI_INTENT_APPS: {
  selected_apps: UpiIntentItems[];
  other_apps: UpiIntentItems[];
} = {
  selected_apps: [
    {
      id: UPI_INTENT.PHONEPE,
      url: `${IMAGE_CDN_URL}/phonepe.jpg`,
      name: "phonepe",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.PAYTM,
      url: `${IMAGE_CDN_URL}/paytm.jpg`,
      name: "paytm",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.BHIM,
      url: `${IMAGE_CDN_URL}/bhim.png`,
      name: "bhim",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.GPAY,
      url: `${IMAGE_CDN_URL}/gpay.png`,
      name: "gpay",
      is_active: true,
      offer_text: "",
    },
  ],
  other_apps: [
    {
      id: UPI_INTENT.POP,
      url: `${IMAGE_CDN_URL}/pop.png`,
      name: "pop",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.NAVI,
      url: `${IMAGE_CDN_URL}/navi.png`,
      name: "navi",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.CRED,
      url: `${IMAGE_CDN_URL}/cred.jpg`,
      name: "cred",
      is_active: true,
      offer_text: "",
    },
    {
      id: UPI_INTENT.AMAZONPAY,
      url: `${IMAGE_CDN_URL}/amazonpay.png`,
      name: "amazon",
      is_active: true,
      offer_text: "",
    },
  ],
};
